import React, {useState, useEffect} from 'react';
import GLOBALS from '../elements/Globals';
import Loader from './Loader';
import img5 from './img/ylogo.png'
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { ReactSession } from 'react-client-session';

const createMarkup = (htmlString) => {
  return { __html: htmlString };
};
const Registration = (props) => {

   ReactSession.setStoreType("localStorage");

   const [loading, setLoading] = useState(false);
   const [pagedata, setPagedata ]= useState("");

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [country, setCountry] = useState('');
  const [dob, setDob] = useState('');
  const [postcode, setPostcode] = useState('');
  const [returnmessage, setReturnmessage] = useState('');

// Event handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setEmail(value);
    } else if (name === 'password') {
      setPassword(value);
    }else if (name === 'fname') {
      setFname(value);
    }else if (name === 'lname') {
      setLname(value);
    }else if (name === 'country') {
      setCountry(value);
    }else if (name === 'dob') {
      setDob(value);
    }else if (name === 'postcode') {
      setPostcode(value);
    }
  };

  $('#togglePassword').on('click', function(event){
   event.stopImmediatePropagation();
   if($('#userpassword').attr('type') === 'password'){
     $('#passwordShow').hide();
     $('#passwordHide').show();
     $('#userpassword').attr('type', 'text');
   }else{
     $('#passwordShow').show();
     $('#passwordHide').hide();
     $('#userpassword').attr('type', 'password');
   }
 })

  async function sendForm() {
      setLoading(true)
      let apiUrl = 'registration';
      const url = GLOBALS.API_BASE_URL+apiUrl;
      try {

        $.ajax({
          type: "POST",
          url: url,
          data: 'email='+email+'&password='+password+'&fname='+fname+'&lname='+lname+'&country='+country+'&dob='+dob+'&postcode='+postcode,
          cache: false,
          success: function(data){
             if(data.status == 1){
               ReactSession.set("user", data.user);
               ReactSession.set("loggedin", 1);
               window.location.href = "";
             }else{
              var message = data.message;
              alert(message)
              setReturnmessage(message);
              $('#errorMessageSection').show();
              setLoading(false)
             }
          }
        });
      } catch (error) {
        console.error(error.message);
      }
    }
  
    // Event handler for form submission
    const handleSubmit = (event) => {
      event.preventDefault();
  
      sendForm();
  
      setEmail('');
      setPassword('');
    };

return (
<>
<div className='sing_in_contend'>
<link rel="stylesheet" href="/assets/css/login-style.css?v=20220823.00"></link>
<header className="header">
   <div aria-label="Mvpboxing Logo" className="logo logo-primary" data-testid="-logo" id="logo" role="img">
      <Link to="/">
      <img className="login_logo_image ls-is-cached lazyloaded" data-src="https://www.mvpboxing.com/assets/images/logo-new.png" alt="MVP BOXING" src="https://www.mvpboxing.com/assets/images/logo-new.png" />
   </Link>
   </div>
</header>
<div className="BodyContainer-sc-4rz3ia-0 sing_in_box">
<Link to='/signin'>
<div className="styles__TopNavBodyWrapper-sc-1858ovt-0 fBXGQW">
   <button aria-label="Back Button" aria-pressed="false" role="button" type="button" className="styles__BackButtonWrapper-sc-f5wfdc-0 kBlYfW">
      <svg className='svg_registration' color="#000000" viewBox="0 0 1024 1024" >
         <path d="M669.387 819.803l11.080-11.11c12.186-11.52 13.21-24.719 0.666-37.263l-260.004-259.686 260.004-259.338c12.175-12.175 11.52-25.733-0.666-37.253l-11.090-11.090c-12.175-11.52-25.733-11.52-37.253 0l-289.075 289.065c-12.175 12.175-12.175 25.078 0 37.253l289.075 289.423c11.52 11.52 24.719 11.878 37.263 0z" />
      </svg>
   </button>
</div>
</Link>
<div className="styles__BodyWrapper-sc-1858ovt-1 dbHsLn">
<div data-testid="sign-up" className="styles__Container-sc-xxfswo-1 iWBcxu">
   <div className="styles__TextWrapper-sc-xxfswo-2 hGTQoy">
      <div data-testid="logo-container" className="styles__LogoContainer-sc-11jlv0z-0 jduJqv"></div>
      <h1 role="header" className="styles__HeaderText-sc-xxfswo-5 firAP">Create an account to continue</h1>
      {/*<p className="styles__DescriptionText-sc-xxfswo-6 boYUgX">Get the latest news on your team, follow your favorite players, and manage your subscriptions</p>*/}
   </div>
   <div id="errorMessageSection" class="alert alert-danger" role="alert">
        {returnmessage}
   </div>
   <form method='post' onSubmit={handleSubmit}>
   <div className='line_line'/>
      <div className="styles__InputBoxWrapper-sc-xxfswo-3 jXBVrB">
         <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
            <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
              <input autoCapitalize="sentences" autoComplete="email" 
                maxLength={160} 
                placeholder="Email" 
                autoCorrect="on" dir="auto" 
                inputMode="email" rows={1} 
                spellCheck="true" 
                type="email" 
                virtualkeyboardpolicy="auto" 
                aria-describedby="emailTestId-label" 
                aria-label="Email" aria-required="true" 
                className="css-11aywtz r-6taxm2 r-14lw9ot r-1voc4r3 r-z2wwpe r-rs99b7 r-1khnkhu r-1b43r93 r-eu3ka r-nwxazl r-1mkv55d r-ubg91z r-mb774y" id="emailTestId-field" 
                data-testid="emailTestId" 
                required
                name='email'
                value={email}
                onChange={handleChange}
                />
              </div>
         </div>
      </div>
      <div className="styles__PasswordInput-sc-xxfswo-4 kTshDj">
         <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
            <div className="styles__Container-sc-dzwwyq-0 gHmJWS password-container" >
              <input autoCapitalize="sentences" autoComplete="new-password" 
                maxLength={160} 
                placeholder="Password" 
                autoCorrect="on" 
                dir="auto" 
                inputMode="text" 
                rows={1} 
                spellCheck="true" 
                type="password" 
                virtualkeyboardpolicy="auto" 
                aria-describedby="passwordTestId-label" 
                aria-label="Password" 
                aria-required="true" 
                className="css-11aywtz r-6taxm2 r-14lw9ot r-1voc4r3 r-z2wwpe r-rs99b7 r-1khnkhu r-1b43r93 r-eu3ka r-nwxazl r-1mkv55d r-ubg91z r-mb774y ownid-skip-password" id="passwordTestId-field" 
                data-testid="passwordTestId"
                required
                name='password'
                id="userpassword"
                value={password}
                onChange={handleChange}
               />
               <span className="toggle-password" id="togglePassword">
                  <svg id="passwordHide" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_178_13892)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0011 18C8.63237 18 5.4638 16.0754 2.44714 11.9998C5.46419 7.92435 8.63259 6 12.0011 6C15.3699 6 18.5384 7.9246 21.5551 12.0002C18.5381 16.0757 15.3697 18 12.0011 18ZM12.0011 4C7.5541 4 3.72153 6.69306 0.396231 11.4248L-0.0078125 11.9997L0.396182 12.5747C3.72105 17.3066 7.55383 20 12.0011 20C16.4481 20 20.2807 17.3069 23.606 12.5752L24.0101 12.0003L23.6061 11.4253C20.2812 6.69339 16.4484 4 12.0011 4ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z" fill="#86898F"></path></g><defs><clipPath id="clip0_178_13892"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>
                  <svg id='passwordShow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_57_3880)"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.666 4.74742C22.0788 4.3805 22.1159 3.74843 21.749 3.33565C21.3821 2.92286 20.75 2.88568 20.3373 3.2526L17.6904 5.60537C15.9141 4.55556 14.021 3.99998 12.0011 3.99998C7.5541 3.99998 3.72153 6.69304 0.396231 11.4248L-0.0078125 11.9997L0.396182 12.5746C1.72195 14.4615 3.12847 16.0242 4.62251 17.2213L2.33725 19.2526C1.92447 19.6195 1.88729 20.2516 2.25421 20.6644C2.62113 21.0772 3.2532 21.1143 3.66598 20.7474L6.31249 18.395C8.08863 19.4445 9.98151 20 12.0011 20C16.4481 20 20.2807 17.3069 23.606 12.5752L24.0101 12.0003L23.6061 11.4253C22.2805 9.53872 20.8741 7.97616 19.3803 6.77915L21.666 4.74742ZM16.1043 7.0152C14.7689 6.33295 13.4023 5.99998 12.0011 5.99998C8.63259 5.99998 5.46419 7.92433 2.44714 11.9998C3.65324 13.6293 4.88362 14.9149 6.14137 15.8712L7.67403 14.5088C7.24544 13.7714 7 12.9143 7 12C7 9.23856 9.23858 6.99998 12 6.99998C13.1248 6.99998 14.1629 7.37142 14.9983 7.99834L16.1043 7.0152ZM16.3271 9.49309L17.8614 8.12923C19.119 9.08545 20.3492 10.3709 21.5551 12.0002C18.5381 16.0756 15.3697 18 12.0011 18C10.6001 18 9.23379 17.6671 7.89858 16.9851L9.00349 16.003C9.83855 16.6291 10.876 17 12 17C14.7614 17 17 14.7614 17 12C17 11.0864 16.755 10.2301 16.3271 9.49309ZM13.4511 9.37364C13.0211 9.13554 12.5264 8.99998 12 8.99998C10.3431 8.99998 9 10.3431 9 12C9 12.401 9.07868 12.7836 9.22146 13.1333L13.4511 9.37364ZM10.551 14.6274L14.7794 10.8688C14.9216 11.2179 15 11.5998 15 12C15 13.6568 13.6569 15 12 15C11.4745 15 10.9805 14.8649 10.551 14.6274Z" fill="#86898F"></path></g><defs><clipPath id="clip0_57_3880"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>
               </span>
            </div>
         </div>
         <div /></div>
         <div className="styles__InputBoxWrapper-sc-xxfswo-3 jXBVrB">
            <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
               <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
                <input autoCapitalize="sentences" autoComplete="given-name" 
                  maxLength={40} 
                  placeholder="First Name" 
                  autoCorrect="on" 
                  dir="auto" 
                  inputMode="text" 
                  rows={1} spellCheck="true" 
                  type="text" 
                  virtualkeyboardpolicy="auto" 
                  aria-describedby="firstNameTestId-label" 
                  aria-label="First Name" 
                  aria-required="true" 
                  className="css-11aywtz r-6taxm2 r-14lw9ot r-1voc4r3 r-z2wwpe r-rs99b7 r-1khnkhu r-1b43r93 r-eu3ka r-nwxazl r-1mkv55d r-ubg91z r-mb774y" id="firstNameTestId-field" 
                  data-testid="firstNameTestId" 
                  required
                  name='fname'
                  value={fname}
                  onChange={handleChange}
                />
                </div>
            </div>
         </div>
         <div className="styles__InputBoxWrapper-sc-xxfswo-3 jXBVrB">
            <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
               <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
                <input autoCapitalize="sentences" autoComplete="family-name" 
                  maxLength={40} 
                  placeholder="Last Name" 
                  autoCorrect="on" 
                  dir="auto" 
                  inputMode="text" 
                  rows={1} 
                  spellCheck="true" 
                  type="text" 
                  virtualkeyboardpolicy="auto" 
                  aria-describedby="lastNameTestId-label" 
                  aria-label="Last Name" 
                  aria-required="true" 
                  className="css-11aywtz r-6taxm2 r-14lw9ot r-1voc4r3 r-z2wwpe r-rs99b7 r-1khnkhu r-1b43r93 r-eu3ka r-nwxazl r-1mkv55d r-ubg91z r-mb774y" id="lastNameTestId-field" 
                  data-testid="lastNameTestId" 
                  required
                  name='lname'
                  value={lname}
                  onChange={handleChange}
                />
                </div>
            </div>
         </div>
         <div className="styles__InputBoxWrapper-sc-xxfswo-3 jXBVrB">
            <label htmlFor="dateOfBirth-field" id="dateOfBirth-label" >Date of Birth</label>
            <input data-testid="birthdayTestId" id="dateOfBirth-field" 
              placeholder="MM/DD/YYYY" 
              type="date" 
              aria-describedby="dateOfBirth-label" 
              aria-placeholder="MM/dd/yyyy"  
              style={{borderRadius: 4, height: 40, lineHeight: 40, fontSize: 14, paddingLeft: 15, paddingRight: 15, borderWidth: 1, color: 'rgb(0, 0, 0)', fontFamily: 'All-ProSans-Medium, var(--font-sans-medium)'}} 
              required
              name='dob'
              value={dob}
              onChange={handleChange}
            />
         </div>
         <div className="styles__InputBoxWrapper-sc-xxfswo-3 jXBVrB">
            <label htmlFor="countryDropdown-field" id="countryDropdown-label" aria-hidden="false" s>Country</label>
            <select aria-label="Country" aria-labelledby="countryDropdown-label" 
              autoComplete="country-name" 
              id="countryDropdown-field" 
              required
              name='country'
              value={country}
              onChange={handleChange}
            >
               <option label="Afghanistan" value="AF">Afghanistan</option>
               <option label="Albania" value="AL">Albania</option>
               <option label="Algeria" value="DZ">Algeria</option>
               <option label="American Samoa" value="AS">American Samoa</option>
               <option label="Andorra" value="AD">Andorra</option>
               <option label="Angola" value="AO">Angola</option>
               <option label="Anguilla" value="AI">Anguilla</option>
               <option label="Antarctica" value="AQ">Antarctica</option>
               <option label="Antigua and Barbuda" value="AG">Antigua and Barbuda</option>
               <option label="Argentina" value="AR">Argentina</option>
               <option label="Armenia" value="AM">Armenia</option>
               <option label="Aruba" value="AW">Aruba</option>
               <option label="Australia" value="AU">Australia</option>
               <option label="Austria" value="AT">Austria</option>
               <option label="Azerbaijan" value="AZ">Azerbaijan</option>
               <option label="Bahamas" value="BS">Bahamas</option>
               <option label="Bahrain" value="BH">Bahrain</option>
               <option label="Bangladesh" value="BD">Bangladesh</option>
               <option label="Barbados" value="BB">Barbados</option>
               <option label="Belarus" value="BY">Belarus</option>
               <option label="Belgium" value="BE">Belgium</option>
               <option label="Belize" value="BZ">Belize</option>
               <option label="Benin" value="BJ">Benin</option>
               <option label="Bermuda" value="BM">Bermuda</option>
               <option label="Bhutan" value="BT">Bhutan</option>
               <option label="Bolivia" value="BO">Bolivia</option>
               <option label="Bosnia and Herzegovina" value="BA">Bosnia and Herzegovina</option>
               <option label="Botswana" value="BW">Botswana</option>
               <option label="Brazil" value="BR">Brazil</option>
               <option label="British Indian Ocean Territory" value="IO">British Indian Ocean Territory</option>
               <option label="British Virgin Islands" value="VG">British Virgin Islands</option>
               <option label="Brunei" value="BN">Brunei</option>
               <option label="Bulgaria" value="BG">Bulgaria</option>
               <option label="Burkina Faso" value="BF">Burkina Faso</option>
               <option label="Burundi" value="BI">Burundi</option>
               <option label="Cambodia" value="KH">Cambodia</option>
               <option label="Cameroon" value="CM">Cameroon</option>
               <option label="Canada" value="CA">Canada</option>
               <option label="Cape Verde" value="CV">Cape Verde</option>
               <option label="Cayman Islands" value="KY">Cayman Islands</option>
               <option label="Central African Republic" value="CF">Central African Republic</option>
               <option label="Chad" value="TD">Chad</option>
               <option label="Chile" value="CL">Chile</option>
               <option label="China" value="CN">China</option>
               <option label="Christmas Island" value="CX">Christmas Island</option>
               <option label="Cocos Islands" value="CC">Cocos Islands</option>
               <option label="Colombia" value="CO">Colombia</option>
               <option label="Comoros" value="KM">Comoros</option>
               <option label="Cook Islands" value="CK">Cook Islands</option>
               <option label="Costa Rica" value="CR">Costa Rica</option>
               <option label="Croatia" value="HR">Croatia</option>
               <option label="Cuba" value="CU">Cuba</option>
               <option label="Curacao" value="CW">Curacao</option>
               <option label="Cyprus" value="CY">Cyprus</option>
               <option label="Czech Republic" value="CZ">Czech Republic</option>
               <option label="Democratic Republic of the Congo" value="CD">Democratic Republic of the Congo</option>
               <option label="Denmark" value="DK">Denmark</option>
               <option label="Djibouti" value="DJ">Djibouti</option>
               <option label="Dominica" value="DM">Dominica</option>
               <option label="Dominican Republic" value="DO">Dominican Republic</option>
               <option label="East Timor" value="TL">East Timor</option>
               <option label="Ecuador" value="EC">Ecuador</option>
               <option label="Egypt" value="EG">Egypt</option>
               <option label="El Salvador" value="SV">El Salvador</option>
               <option label="Equatorial Guinea" value="GQ">Equatorial Guinea</option>
               <option label="Eritrea" value="ER">Eritrea</option>
               <option label="Estonia" value="EE">Estonia</option>
               <option label="Ethiopia" value="ET">Ethiopia</option>
               <option label="Falkland Islands" value="FK">Falkland Islands</option>
               <option label="Faroe Islands" value="FO">Faroe Islands</option>
               <option label="Fiji" value="FJ">Fiji</option>
               <option label="Finland" value="FI">Finland</option>
               <option label="France" value="FR">France</option>
               <option label="French Polynesia" value="PF">French Polynesia</option>
               <option label="Gabon" value="GA">Gabon</option>
               <option label="Gambia" value="GM">Gambia</option>
               <option label="Georgia" value="GE">Georgia</option>
               <option label="Germany" value="DE">Germany</option>
               <option label="Ghana" value="GH">Ghana</option>
               <option label="Gibraltar" value="GI">Gibraltar</option>
               <option label="Greece" value="GR">Greece</option>
               <option label="Greenland" value="GL">Greenland</option>
               <option label="Grenada" value="GD">Grenada</option>
               <option label="Guam" value="GU">Guam</option>
               <option label="Guatemala" value="GT">Guatemala</option>
               <option label="Guernsey" value="GG">Guernsey</option>
               <option label="Guinea" value="GN">Guinea</option>
               <option label="Guinea-Bissau" value="GW">Guinea-Bissau</option>
               <option label="Guyana" value="GY">Guyana</option>
               <option label="Haiti" value="HT">Haiti</option>
               <option label="Honduras" value="HN">Honduras</option>
               <option label="Hong Kong" value="HK">Hong Kong</option>
               <option label="Hungary" value="HU">Hungary</option>
               <option label="Iceland" value="IS">Iceland</option>
               <option label="India" value="IN" aria-selected="true">India</option>
               <option label="Indonesia" value="ID">Indonesia</option>
               <option label="Iran" value="IR">Iran</option>
               <option label="Iraq" value="IQ">Iraq</option>
               <option label="Ireland" value="IE">Ireland</option>
               <option label="Isle of Man" value="IM">Isle of Man</option>
               <option label="Israel" value="IL">Israel</option>
               <option label="Italy" value="IT">Italy</option>
               <option label="Ivory Coast" value="CI">Ivory Coast</option>
               <option label="Jamaica" value="JM">Jamaica</option>
               <option label="Japan" value="JP">Japan</option>
               <option label="Jersey" value="JE">Jersey</option>
               <option label="Jordan" value="JO">Jordan</option>
               <option label="Kazakhstan" value="KZ">Kazakhstan</option>
               <option label="Kenya" value="KE">Kenya</option>
               <option label="Kiribati" value="KI">Kiribati</option>
               <option label="Kosovo" value="XK">Kosovo</option>
               <option label="Kuwait" value="KW">Kuwait</option>
               <option label="Kyrgyzstan" value="KG">Kyrgyzstan</option>
               <option label="Laos" value="LA">Laos</option>
               <option label="Latvia" value="LV">Latvia</option>
               <option label="Lebanon" value="LB">Lebanon</option>
               <option label="Lesotho" value="LS">Lesotho</option>
               <option label="Liberia" value="LR">Liberia</option>
               <option label="Libya" value="LY">Libya</option>
               <option label="Liechtenstein" value="LI">Liechtenstein</option>
               <option label="Lithuania" value="LT">Lithuania</option>
               <option label="Luxembourg" value="LU">Luxembourg</option>
               <option label="Macao" value="MO">Macao</option>
               <option label="Macedonia" value="MK">Macedonia</option>
               <option label="Madagascar" value="MG">Madagascar</option>
               <option label="Malawi" value="MW">Malawi</option>
               <option label="Malaysia" value="MY">Malaysia</option>
               <option label="Maldives" value="MV">Maldives</option>
               <option label="Mali" value="ML">Mali</option>
               <option label="Malta" value="MT">Malta</option>
               <option label="Marshall Islands" value="MH">Marshall Islands</option>
               <option label="Mauritania" value="MR">Mauritania</option>
               <option label="Mauritius" value="MU">Mauritius</option>
               <option label="Mayotte" value="YT">Mayotte</option>
               <option label="Mexico" value="MX">Mexico</option>
               <option label="Micronesia" value="FM">Micronesia</option>
               <option label="Moldova" value="MD">Moldova</option>
               <option label="Monaco" value="MC">Monaco</option>
               <option label="Mongolia" value="MN">Mongolia</option>
               <option label="Montenegro" value="ME">Montenegro</option>
               <option label="Montserrat" value="MS">Montserrat</option>
               <option label="Morocco" value="MA">Morocco</option>
               <option label="Mozambique" value="MZ">Mozambique</option>
               <option label="Myanmar" value="MM">Myanmar</option>
               <option label="Namibia" value="NA">Namibia</option>
               <option label="Nauru" value="NR">Nauru</option>
               <option label="Nepal" value="NP">Nepal</option>
               <option label="Netherlands" value="NL">Netherlands</option>
               <option label="Netherlands Antilles" value="AN">Netherlands Antilles</option>
               <option label="New Caledonia" value="NC">New Caledonia</option>
               <option label="New Zealand" value="NZ">New Zealand</option>
               <option label="Nicaragua" value="NI">Nicaragua</option>
               <option label="Niger" value="NE">Niger</option>
               <option label="Nigeria" value="NG">Nigeria</option>
               <option label="Niue" value="NU">Niue</option>
               <option label="North Korea" value="KP">North Korea</option>
               <option label="Northern Mariana Islands" value="MP">Northern Mariana Islands</option>
               <option label="Norway" value="NO">Norway</option>
               <option label="Oman" value="OM">Oman</option>
               <option label="Pakistan" value="PK">Pakistan</option>
               <option label="Palau" value="PW">Palau</option>
               <option label="Palestine" value="PS">Palestine</option>
               <option label="Panama" value="PA">Panama</option>
               <option label="Papua New Guinea" value="PG">Papua New Guinea</option>
               <option label="Paraguay" value="PY">Paraguay</option>
               <option label="Peru" value="PE">Peru</option>
               <option label="Philippines" value="PH">Philippines</option>
               <option label="Pitcairn" value="PN">Pitcairn</option>
               <option label="Poland" value="PL">Poland</option>
               <option label="Portugal" value="PT">Portugal</option>
               <option label="Puerto Rico" value="PR">Puerto Rico</option>
               <option label="Qatar" value="QA">Qatar</option>
               <option label="Republic of the Congo" value="CG">Republic of the Congo</option>
               <option label="Reunion" value="RE">Reunion</option>
               <option label="Romania" value="RO">Romania</option>
               <option label="Russia" value="RU">Russia</option>
               <option label="Rwanda" value="RW">Rwanda</option>
               <option label="Saint Barthelemy" value="BL">Saint Barthelemy</option>
               <option label="Saint Helena" value="SH">Saint Helena</option>
               <option label="Saint Kitts and Nevis" value="KN">Saint Kitts and Nevis</option>
               <option label="Saint Lucia" value="LC">Saint Lucia</option>
               <option label="Saint Martin" value="MF">Saint Martin</option>
               <option label="Saint Pierre and Miquelon" value="PM">Saint Pierre and Miquelon</option>
               <option label="Saint Vincent and the Grenadines" value="VC">Saint Vincent and the Grenadines</option>
               <option label="Samoa" value="WS">Samoa</option>
               <option label="San Marino" value="SM">San Marino</option>
               <option label="Sao Tome and Principe" value="ST">Sao Tome and Principe</option>
               <option label="Saudi Arabia" value="SA">Saudi Arabia</option>
               <option label="Senegal" value="SN">Senegal</option>
               <option label="Serbia" value="RS">Serbia</option>
               <option label="Seychelles" value="SC">Seychelles</option>
               <option label="Sierra Leone" value="SL">Sierra Leone</option>
               <option label="Singapore" value="SG">Singapore</option>
               <option label="Sint Maarten" value="SX">Sint Maarten</option>
               <option label="Slovakia" value="SK">Slovakia</option>
               <option label="Slovenia" value="SI">Slovenia</option>
               <option label="Solomon Islands" value="SB">Solomon Islands</option>
               <option label="Somalia" value="SO">Somalia</option>
               <option label="South Africa" value="ZA">South Africa</option>
               <option label="South Korea" value="KR">South Korea</option>
               <option label="South Sudan" value="SS">South Sudan</option>
               <option label="Spain" value="ES">Spain</option>
               <option label="Sri Lanka" value="LK">Sri Lanka</option>
               <option label="Sudan" value="SD">Sudan</option>
               <option label="Suriname" value="SR">Suriname</option>
               <option label="Svalbard and Jan Mayen" value="SJ">Svalbard and Jan Mayen</option>
               <option label="Swaziland" value="SZ">Swaziland</option>
               <option label="Sweden" value="SE">Sweden</option>
               <option label="Switzerland" value="CH">Switzerland</option>
               <option label="Syria" value="SY">Syria</option>
               <option label="Taiwan" value="TW">Taiwan</option>
               <option label="Tajikistan" value="TJ">Tajikistan</option>
               <option label="Tanzania" value="TZ">Tanzania</option>
               <option label="Thailand" value="TH">Thailand</option>
               <option label="Togo" value="TG">Togo</option>
               <option label="Tokelau" value="TK">Tokelau</option>
               <option label="Tonga" value="TO">Tonga</option>
               <option label="Trinidad and Tobago" value="TT">Trinidad and Tobago</option>
               <option label="Tunisia" value="TN">Tunisia</option>
               <option label="Turkey" value="TR">Turkey</option>
               <option label="Turkmenistan" value="TM">Turkmenistan</option>
               <option label="Turks and Caicos Islands" value="TC">Turks and Caicos Islands</option>
               <option label="Tuvalu" value="TV">Tuvalu</option>
               <option label="U.S. Virgin Islands" value="VI">U.S. Virgin Islands</option>
               <option label="Uganda" value="UG">Uganda</option>
               <option label="Ukraine" value="UA">Ukraine</option>
               <option label="United Arab Emirates" value="AE">United Arab Emirates</option>
               <option label="United Kingdom" value="GB">United Kingdom</option>
               <option label="United States" value="US">United States</option>
               <option label="Uruguay" value="UY">Uruguay</option>
               <option label="Uzbekistan" value="UZ">Uzbekistan</option>
               <option label="Vanuatu" value="VU">Vanuatu</option>
               <option label="Vatican" value="VA">Vatican</option>
               \
               <option label="Venezuela" value="VE">Venezuela</option>
               <option label="Vietnam" value="VN">Vietnam</option>
               <option label="Wallis and Futuna" value="WF">Wallis and Futuna</option>
               <option label="Western Sahara" value="EH">Western Sahara</option>
               <option label="Yemen" value="YE">Yemen</option>
               <option label="Zambia" value="ZM">Zambia</option>
               <option label="Zimbabwe" value="ZW">Zimbabwe</option>
            </select>
         </div>
         <div className="styles__InputBoxWrapper-sc-xxfswo-3 jXBVrB">
            <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
               <label htmlFor="zipTestId-field" id="zipTestId-label" >Postal Code (Optional)</label>
               <div className="styles__Container-sc-dzwwyq-0 gHmJWS">
                  <input autoCapitalize="sentences" autoComplete="postal-code" 
                    maxLength={160} placeholder="Enter postal code" 
                    autoCorrect="on" dir="auto" 
                    inputMode="text" rows={1} 
                    spellCheck="true" type="text" 
                    virtualkeyboardpolicy="auto" 
                    aria-describedby="zipTestId-label" 
                    aria-label="Postal Code (Optional)" 
                    aria-required="false" 
                    className="css-11aywtz r-6taxm2 r-14lw9ot r-1voc4r3 r-z2wwpe r-rs99b7 r-1khnkhu r-1b43r93 r-eu3ka r-nwxazl r-1mkv55d r-ubg91z r-mb774y" id="zipTestId-field" 
                    data-testid="zipTestId"  
                    name='postcode'
                    value={postcode}
                    onChange={handleChange}
                  />
               </div>
            </div>
         </div>
         <div className="css-175oi2r">
            <div className=" r-1habvwh r-18u37iz r-1wzrnnt">
               <div className="r-1awozwy r-14lw9ot r-z2wwpe r-rs99b7 r-1777fci checkbox_reg">
                  <input aria-checked="false" aria-label="Consent Checkbox" 
                    aria-labelledby="marketingOptInId-chkbox" 
                    id="marketingOptInId" 
                    type="checkbox" 
                    required 
                  />
               </div>
               <label htmlFor="marketingOptInId" id="marketingOptInId-chkbox" >I agree to MVP BOXING’S Terms of Service and understand that personal information will be used as described in MVP BOXING’S Privacy Policy.</label>
            </div>
            <div className="r-1habvwh r-18u37iz r-1wzrnnt">
               <div className="styles__WarningText-sc-9xi3v2-0 jpLSyP">
                  <p>By clicking “Create Account“, I agree to the MVP BOXING’s </p>
                  <Link to="/terms_of_use" target="blank" className="styles__HighlightedLink-sc-9xi3v2-1 fqGjgu">
                  Terms of Service</Link>
                  <p> and understand that personal information will be used as described in the MVP BOXING’s </p>
                  <Link to="/privacy_Policy" target="blank" className="styles__HighlightedLink-sc-9xi3v2-1 fqGjgu">
                  Privacy Policy</Link>
               </div>
            </div>
         </div>
         <div className="css-175oi2r account_reg">
            <Loader loading={loading} />
            <button aria-disabled="false" aria-label="Create Account" height={40} role="button" type="submit" value="Create Account" width="100%" className="styles__StyledButton-sc-8qc5s2-0 hqtidt">
               <div className='Create_account_reg'><span className="styles__StyledText-sc-8qc5s2-1 dECuhf">Create Account</span></div>
            </button>
         </div>
         </form>
         <div className="styles__TextWrapper-sc-xxfswo-2 hGTQoy">
            <p className="styles__WarningText-sc-xxfswo-9 cnkjlK">
               Already have an account? 
                <Link to='/signin' className="styles__HighlightedLink-sc-xxfswo-10 eamvOU">&nbsp;
                Sign In</Link>
            </p>
         </div>
         <div className='line_line'></div>
         <div />
            <div data-testid="language-selector" className="styles__LangSelectorWrapper-sc-z69cid-0 huoexK">
               <label htmlFor="language-selector-field" id="language-selector-label" aria-hidden="true" >Select a Language</label>
               <select aria-label="Select a Language" aria-labelledby="language-selector-label" id="language-selector-field" >
                  <option label="English" value="en" aria-selected="true">English</option>
                  <option label="Spanish" value="es">Spanish</option>
                  <option label="Japanese" value="ja">Japanese</option>
                  <option label="German" value="de">German</option>
                  <option label="Portuguese" value="pt">Portuguese</option>
                  <option label="French" value="fr">French</option>
               </select>
            </div>
         </div>
      </div>
   </div>
</div>
</>
)
};
export default Registration;